import React, { useEffect } from 'react';

import styled from 'styled-components';

import { ActivityActions } from '../../infrastructure/constants/activities';

import ItemOptionLabel from './ItemOptionLabel';

const StyledActionsContainer = styled.div`
  position: absolute;
  left: -113px;
  top: 31px;

  z-index: 1;

  width: 261px;
  background: #f7f7f7;
`;

const StyledActionLink = styled.a`
    display: inline-block
    position: relative;
    background: none;
    
    width: 100%;
    padding: 10px 20px 10px 50px;
    margin: 0;
        
    color: #000000;
    font-size: 15px;
    text-decoration: none;
    text-align: left;
    
   &:hover {
        background: #FBEBD9;
        text-decoration: none;
   } 
   
   img {
        height: auto;
        position: absolute;
        left: 10px;
        top: 9px;  
   }
`;

const StyleActionButton = styled(StyledActionLink)`
  outline: none;
  border: none;
`;

type Props = {
  actions: ActivityActions[];
  closeActions: () => void;
  setCopyAlert: (str: string) => void;
};

const ItemActionsContainer = ({
  actions,
  closeActions,
  setCopyAlert,
}: Props) => {
  const onWindowClick = () => {
    closeActions();
  };

  useEffect(() => {
    window.addEventListener('click', onWindowClick);
    return () => {
      window.removeEventListener('click', onWindowClick);
    };
  }, []);

  const onActionClick = (action: ActivityActions) => {
    navigator.clipboard.writeText(action.href);
    setCopyAlert('Copied to clipboard!');
  };

  return (
    <StyledActionsContainer>
      {actions.map(action => {
        if (!action.show) return null;
        return (
          <>
            {action.type === 'button' ? (
              <StyleActionButton
                key={`${action}+${Math.random()}`}
                type='button'
                onClick={() => onActionClick(action)}
              >
                <ItemOptionLabel action={action} />
              </StyleActionButton>
            ) : (
              <StyledActionLink
                href={action.href}
                rel='noopener noreferrer'
                target='_blank'
              >
                <ItemOptionLabel action={action} />
              </StyledActionLink>
            )}
          </>
        );
      })}
    </StyledActionsContainer>
  );
};

export default ItemActionsContainer;
